/*
 * Copyright (c) Worldline 2022.
 */

import {Component, Input, OnInit} from '@angular/core';
import {ExternalEvidenceStatus} from "../../constant/external-evidence-status";
import {ExternalEvidenceTempDataStatus} from "../../constant/external-evidence-temp-data-status";
import {SharedService} from "../../services/shared.service";
import {ExternalEvidencePartStatus} from "../../constant/external-evidence-part-status";
import {PopoverMode} from "../../constant/popover-mode";
import {EvidenceService} from "../../services/evidence.service";
import {SessionService} from "../../services/session.service";
import {SignerService} from "../../services/signer.service";
import {RootScopeService} from "../../services/rootscope.service";
import {EvidenceUserHelperService} from "../../services/evidence-user-helper.service";
import {HttpService} from "../../http/http.service";

@Component({
    selector: 'app-wl-evidence',
    templateUrl: './wl-evidence.component.html'
})
export class WlEvidenceComponent implements OnInit {

    constructor(public rootScope: RootScopeService,
                private sharedService: SharedService,
                private evidenceService: EvidenceService,
                private sessionService: SessionService,
                private signersService: SignerService,
                private evidenceUserHelperService: EvidenceUserHelperService,
                private httpService: HttpService) {
    }

    /**
     * The evidence object
     */
    @Input()
    evidencewithtemp: any;

    /**
     * The evidence number
     */
    @Input()
    num: any;


    ids = {
        sessionId: this.sessionService.id,
        signerId: this.signersService.currentSigner.extSignerId,
        evidenceId: null
    };
    canAddMorePart = false;
    openPopoverEvidence: any;
    externalEvidenceStatus: any;
    popoverMode: any;
    elementType: any;
    evidenceMsg: any;

    ngOnInit(): void {
        const that = this;
        this.ids.evidenceId = this.evidencewithtemp.evidenceDto.extEvidenceId

        if (typeof (this.rootScope.get().popoverTable) === 'undefined') {
            this.evidenceUserHelperService.createPopoverTable();
        }

        //Add keys on popover table
        for (var i = 0; i < this.evidencewithtemp.evidenceDto.availableTypes.length; i++) {
            this.evidenceUserHelperService.registerPopoverButton('help-choiceButton_' + this.num + '-' + i);
        }

        //Update scope from the rootScope
        this.openPopoverEvidence = this.rootScope.get().openPopover;

        //Pass enums constants to html
        this.externalEvidenceStatus = ExternalEvidenceStatus;
        this.popoverMode = PopoverMode;

        if (this.evidencewithtemp.evidenceDto.description === '') {
            this.evidencewithtemp.evidenceDto.description = null;
        }

        if ((this.evidencewithtemp.evidenceDto.evidenceType !== null) && (this.evidencewithtemp.evidenceDto.evidenceContentType === 'MULTI')) {
            if (this.evidencewithtemp.evidenceDto.parts.length >= this.evidencewithtemp.evidenceDto.maxPartNumber) {
                this.canAddMorePart = false;
            } else {
                if (this.evidencewithtemp.evidenceDto.parts.length > 1) {
                    this.canAddMorePart = true;
                } else {
                    if (this.evidencewithtemp.evidenceDto.parts[0].externalEvidencePartStatus !== ExternalEvidencePartStatus.toUpload) {
                        this.canAddMorePart = true;
                    } else {
                        this.canAddMorePart = false;
                    }
                }
            }
        }

        if (this.evidencewithtemp.evidenceDto.evidenceContentType === 'MULTI') {
            this.elementType = this.evidencewithtemp.evidenceDto.parts[0].elementType;
        }

        this.sharedService.on('updatePart', function (event) {

            console.debug('update part !!');

            //A part has been uploaded and get, check if evidence is concerned
            if (that.evidencewithtemp.evidenceDto.extEvidenceId === event.data.evidenceId) {
                console.debug('Upload for evidence ' + event.data.evidenceId);


                var partFound = false;
                for (var i = 0; i < that.evidencewithtemp.evidenceDto.parts.length; i++) {
                    if (that.evidencewithtemp.evidenceDto.parts[i].extEvidencePartId === event.data.part.extEvidencePartId) {
                        that.evidencewithtemp.evidenceDto.parts[i] = event.data.part;
                        partFound = true;
                    }
                }

                //If part has been found
                if (partFound) {
                    //Check if button "'add part" can be displayed
                    if ((that.evidencewithtemp.evidenceDto.evidenceContentType === 'MULTI') && (that.evidencewithtemp.evidenceDto.parts[0].externalEvidencePartStatus !== ExternalEvidencePartStatus.toUpload)) {
                        that.canAddMorePart = true;
                    }
                }
                //Part has not been found, must be added
                else {
                    console.debug('New upload for evidence ' + event.data.evidenceId);

                    that.evidencewithtemp.evidenceDto.parts[that.evidencewithtemp.evidenceDto.parts.length] = event.data.part;

                    //Check if button "'add part" can be displayed
                    if ((that.evidencewithtemp.evidenceDto.evidenceContentType === 'MULTI') && (that.evidencewithtemp.evidenceDto.parts[0].externalEvidencePartStatus !== ExternalEvidencePartStatus.toUpload)) {
                        that.canAddMorePart = true;
                    }
                    if (that.evidencewithtemp.evidenceDto.parts.length >= that.evidencewithtemp.evidenceDto.maxPartNumber) {
                        that.canAddMorePart = false;
                    }
                }

                //Send send same event for parent
                let data = {
                    evidenceId: event.data.evidenceId,
                    evidence: that.evidencewithtemp.evidenceDto
                };
                that.sharedService.broadcast('updateEvidence', data);
            }

        });

        this.sharedService.on('uploadFailed', function (event) {

            console.debug('uploadFailed with data : ' + event.data);
            //A part failed to upload, check if evidence id concerned
            if (that.evidencewithtemp.evidenceDto.extEvidenceId === event.data.evidenceId) {

                //Check if evidence is multi content type
                if (that.evidencewithtemp.evidenceDto.evidenceContentType === 'MULTI') {
                    //Check if first part is uploaded -> display add part
                    if (that.evidencewithtemp.evidenceDto.parts[0].externalEvidencePartStatus !== ExternalEvidencePartStatus.toUpload) {
                        that.canAddMorePart = true;
                    }
                    //First part not uploaded
                    else {
                        //If several parts in scope
                        if (that.evidencewithtemp.evidenceDto.parts.length > 1) {
                            //If max parts in scope -> do not display add part
                            if (that.evidencewithtemp.evidenceDto.parts.length >= that.evidencewithtemp.evidenceDto.maxPartNumber) {
                                that.canAddMorePart = false;
                            }
                            //Parts can be added
                            else {
                                that.canAddMorePart = true;
                            }
                        }
                        //Only one part in scope, not uploaded -> do not display add part
                        else {
                            that.canAddMorePart = false;
                        }
                    }
                }
            }
        });

        this.sharedService.on('deletePart', function (event) {
            //If right evidence
            if (that.evidencewithtemp.evidenceDto.extEvidenceId === event.data.evidenceId) {
                console.debug('Delete for evidence ' + event.data.evidenceId);
                that.evidencewithtemp.evidenceDto.parts = event.data.parts;

                console.debug('will deactivate : ' + that.evidencewithtemp.evidenceDto.parts[0].externalEvidencePartStatus);
                //Check if button "add part" must be removed
                if ((that.evidencewithtemp.evidenceDto.parts.length <= 1) && (that.evidencewithtemp.evidenceDto.parts[0].externalEvidencePartStatus === ExternalEvidencePartStatus.toUpload)) {
                    that.canAddMorePart = false;
                } else if (that.evidencewithtemp.evidenceDto.parts.length < that.evidencewithtemp.evidenceDto.maxPartNumber) {
                    that.canAddMorePart = true;
                }

                let data = {
                    evidenceId: event.data.evidenceId,
                    evidence: that.evidencewithtemp.evidenceDto
                };
                that.sharedService.broadcast('updateEvidence', data);
            }
        });

        if (this.evidencewithtemp.evidenceTempDataDto !== null) {
            var data = {
                sessionId: this.sessionService.id,
                signerId: this.signersService.currentSigner.extSignerId,
                evidenceId: this.evidencewithtemp.evidenceTempDataDto.extEvidenceId,
                evidencePartId: this.evidencewithtemp.evidenceTempDataDto.extEvidencePartId,
                nbPages: this.evidencewithtemp.evidenceTempDataDto.nbPages
            };
            switch (this.evidencewithtemp.evidenceTempDataDto.externalEvidenceTempDataStatus) {
                case ExternalEvidenceTempDataStatus.PROCESSING:
                    this.evidenceService.checkLoop(data.sessionId, data.signerId, data.evidenceId, data.evidencePartId);
                    break;
                case ExternalEvidenceTempDataStatus.AFFECTATION:
                case ExternalEvidenceTempDataStatus.TO_CROP_AND_AFFECTATION:
                case ExternalEvidenceTempDataStatus.TO_CROP:
                    this.evidenceService.verifyEvidence(data.sessionId, data.signerId, data.evidenceId, data.evidencePartId, data.nbPages);
                    break;
            }
        }
    }

    selectType(type) {
        const that = this;

        this.httpService.setEvidenceType(this.sessionService.id, this.signersService.currentSigner.extSignerId, this.evidencewithtemp.evidenceDto.extEvidenceId, type).toPromise().then(function (response) {
            if (response?.success) {
                //Do not show the popover anymore
                that.evidenceUserHelperService.closeAll();

                // Update the evidence
                that.evidencewithtemp.evidenceDto = response.result;

                var data = {
                    evidenceId: that.evidencewithtemp.evidenceDto.extEvidenceId,
                    evidence: that.evidencewithtemp.evidenceDto
                };
                that.sharedService.broadcast('updateEvidence', data);
            } else {
                console.warn(response?.error?.msg);
            }
        }, function (error) {
            console.warn('An error occurred when setting an evidence type');
            console.warn(error);
            that.evidenceMsg = 'error when setting';
        });
    };

    resetType() {
        // Allow reset evidence type when there is no temporary and when evidence state is stable
        if (this.evidencewithtemp.evidenceTempDataDto !== null) {
            // If state is stable (!processing && affected)
            if (this.evidencewithtemp.evidenceTempDataDto.externalEvidenceTempDataStatus !== ExternalEvidenceTempDataStatus.PROCESSING ||
                this.evidencewithtemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.AFFECTED ||
                this.evidencewithtemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.REJECT) {

                console.debug('reset type while externalEvidenceTempDataStatus is ' + this.evidencewithtemp.evidenceTempDataDto.externalEvidenceTempDataStatus);

                this.resetEvidenceType();
            } else {
                console.debug('reset not allowed because externalEvidenceTempDataStatus is ' + this.evidencewithtemp.evidenceTempDataDto.externalEvidenceTempDataStatus);
            }
        } else {
            console.debug('reset type while there is no temporary');

            this.resetEvidenceType();
        }
    };

    hasAvailableTypes() {
        if (this.evidencewithtemp.evidenceDto.availableTypes.length > 1) {
            return true;
        } else {
            return false;
        }
    };

    //Reset evidence type function called on the resetType scope function
    private resetEvidenceType() {
        const that = this;

        this.httpService.resetEvidenceType(this.sessionService.id, that.signersService.currentSigner.extSignerId, this.evidencewithtemp.evidenceDto.extEvidenceId).toPromise().then(function (response) {
            if (response?.success) {
                //Do not show the popover anymore
                that.evidenceUserHelperService.closeAll();

                // Update the evidence
                that.evidencewithtemp.evidenceDto = response.result;

                var data = {
                    evidenceId: that.evidencewithtemp.evidenceDto.extEvidenceId,
                    evidence: that.evidencewithtemp.evidenceDto
                };
                that.sharedService.broadcast('updateEvidence', data);
            } else {
                console.warn(response?.error?.msg);
            }
        }, function (error) {
            console.warn('An error occurred when setting an evidence type');
            console.warn(error);
            that.evidenceMsg = 'error when resetting';
        });
    };
}
